import { render, staticRenderFns } from "./CustomQuestionAnswerDatetime.vue?vue&type=template&id=3b460ef1"
import script from "./CustomQuestionAnswerDatetime.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerDatetime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports